import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240625/padres/vulcans-le_padres-{nnn}b.png',
}

export default {
  supports360: false,
  layers: [body],
  resolveOptions: () => ({}),
}
